import { DivisionsScheduleComponent } from './divisions-schedule.component';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { ShiftService } from '../../../../services/shifts/shift.service';
import { NgModule } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { ChatService } from '../../chat/chat.service';
import { EditTeacherComponent } from './edit-teacher/edit-teacher.component';


const routes = [
    {
        path: 'pages/divisions-schedule/:id',
        component: DivisionsScheduleComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];


@NgModule({
    declarations: [
        DivisionsScheduleComponent,
        EditTeacherComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
        DivisionsScheduleComponent
    ],
    providers: [
        ChatService,
        ShiftService
    ],
    entryComponents: [
        EditTeacherComponent
    ]
})

export class DivisionsScheduleModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/divisions-schedule/divisions-schedule.module.ts